import { render, staticRenderFns } from "./middleContent.vue?vue&type=template&id=daa0241a&scoped=true&"
import script from "./middleContent.vue?vue&type=script&lang=js&"
export * from "./middleContent.vue?vue&type=script&lang=js&"
import style0 from "./middleContent.vue?vue&type=style&index=0&id=daa0241a&prod&lang=scss&scoped=true&"
import style1 from "./middleContent.vue?vue&type=style&index=1&id=daa0241a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa0241a",
  null
  
)

export default component.exports